<style scoped>

</style>
<template>
  <span>
    {{ name }}
  </span>
</template>
<script>
  export default {
    props: {
      id: {
        type: Number,
        required: true
      },
      short: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        //
      }
    },
    computed: {
      teams_hash() {
        return this.$store.getters['async/teams_hash'];
      },
      name() {
        const team = this.teams_hash[this.id];
        return (team && team.name) || '-';
      }
    },
  }
</script>
